import { COLOR, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import { css } from "@emotion/react";
import { destyle } from "./destyle";

export const GLOBAL_STYLE = css`
  ${destyle};

  * {
    --sat: env(safe-area-inset-top);
    --sar: env(safe-area-inset-right);
    --sab: env(safe-area-inset-bottom);
    --sal: env(safe-area-inset-left);
  }

  html {
    padding: var(--sat) var(--sar) var(--sab) var(--sal);
  }

  html,
  body {
    background-color: ${COLOR.GRAY100.code};
    color: ${COLOR.GRAY900.code};
    font-family: "Hiragino Kaku Gothic ProN", "Hiragino Sans", Meiryo, sans-serif;
    line-height: 1.6;
    font-weight: ${FONT_WEIGHT.NORMAL};
    overscroll-behavior: none;
  }

  :is(input, textarea, button, select, a):focus-visible {
    outline: 2px solid ${COLOR.YELLOW900.code};
    outline-offset: -2px;
  }
  //memo 一番下までページスクロールするとオレンジ色になってしまうのでこちらが必要
  #__next:focus-visible {
    outline: none;
  }
`;
